var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddWorkBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.173,
    height: 19.579,
    viewBox: "0 0 25.173 19.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-book-open",
    "data-name": "Icon awesome-book-open",
    d: "M23.7,2.252c-2.395.136-7.155.631-10.094,2.429a.672.672,0,0,0-.318.576v15.9a.692.692,0,0,0,1.017.59c3.023-1.522,7.4-1.937,9.558-2.051a1.363,1.363,0,0,0,1.312-1.34V3.594A1.37,1.37,0,0,0,23.7,2.252ZM11.57,4.682c-2.938-1.8-7.7-2.293-10.093-2.429A1.371,1.371,0,0,0,0,3.594V18.359A1.362,1.362,0,0,0,1.312,19.7c2.163.114,6.538.529,9.561,2.052a.69.69,0,0,0,1.014-.588V5.249A.658.658,0,0,0,11.57,4.682Z",
    transform: "translate(0 -2.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWorkBook);
export default __webpack_public_path__ + "static/media/addWorkBook.1cc49ae90feb52360b8b39ff306e590d.svg";
export { ForwardRef as ReactComponent };